import React, { useState } from "react";
import './bulb.scss';

export const Bulb = () => {
         const[bulbActive, setBulbActive] =useState(false);

         const activeBulb =()=>{
            if (window.scrollY >= 2000) {
                setBulbActive(true);
            }else{
                setBulbActive(false);
            }
         }

 window.addEventListener("scroll",activeBulb);

  return (
    <div className={bulbActive ? 'bulb-on' : 'bulb-page' } >
    <div className="light">
      <div className="wire"></div>
      <div className="bulb">
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
  );
}
export default Bulb;